import React, { useEffect, useMemo, useState } from "react";
import { useLocation, useParams } from 'react-router';
import { useNavigate } from "react-router-dom"
import { useDispatch, useSelector } from "react-redux";
import ReactGA from "react-ga4";

import dataModelos from '../../../../data/AudiNuevo/modelos.json';
import ROUTES from "../../../../utilities/Routes";

import Stage from "../../../../components/Stage";
import ButtonBack from "../../../../components/Buttons/Back";
import InputText from "../../../../components/Inputs/Text";
import InputSelect from "../../../../components/Inputs/Select";
import InputTextArea from "../../../../components/Inputs/TextArea";
import InputCheckBox from "../../../../components/Inputs/Checkbox";
import ReactLoading from "react-loading";

import MetaPixel from "../../../../plugins/audisite/audinuevo/metaPixel";
import TwitterPixel from "../../../../plugins/audisite/audinuevo/twitterPixel";

import { getOnlyAudiCenters, scrollToInput } from "../../../../utilities/utils";

import {
  setTratamientoAction,
  setNombreAction,
  setApellidoPaternoAction,
  // setTelefonoAction,
  setMovilAction,
  setCorreoAction,
  setEstadoAction,
  setCiudadAction,
  setIdConcesionarioAction,
  setConcesionarioAction,
  setVehiculoAction,
  setComentariosAction,
  setAvisosDePrivacidadAction,
  setTerminosCondicionesAction,
  setTransferenciaDeDatosAction,
  setContactoMarketingAction,
  reiniciarStateAction
} from "../../../../actions/audiNuevoActions";

import {
  getEstados,
  getConcesionarios,
} from "../../../../API/CitasServicioRequest/index";

import {
  getCiudades,
} from "../../../../API/ConfiguradorRequest/index";

import {
  isOnlyNumbers,
} from "../../../../utilities/Validations";
import { sendLead, sendMailAudiNuevoCliente, sendMailAudiNuevoConcesionaria } from "../../../../API/AudiNuevoRequest";
import { addUtmsToLead, buildTradeInPayload, validarApellidoPaterno, validarCelular, validarCodigoPostal, validarCorreo, validarNombre } from "../../../../utilities/Validations/lead";
import { sendLeadToSaas } from "../../../../API/SaasRequest";
import FloodlightPixel from "../../../../plugins/audisite/audinuevo/floodlightPixel";
import SeoPixel from "../../../../plugins/seo";
import ConsentMode from "../../../../plugins/template/consentMode";
import { TratoComponent } from "../../../../components/Form/Trato";
import useGoogleTagManager from "../../../../hooks/useGoogleTagManager";
import useUtmParams from "../../../../hooks/useUtmParams";
import { FORM_TYPES, TITLE, LEGALS } from "../../../../data/AudiNuevo/preventa";
import { resolvePreventaQ3Config } from "../../../../data/AudiNuevo/const_preventa_q3";
import LegalesComponent from "../../../../components/Form/Legales";
import TitleComponent from "../../../../components/Form/Title";
import TradeInSection from "../../../../components/Form/TradeInSection";
import { sendTradeIn } from "../../../../API/TradeInRequest";

const tiposDeServicio = [
  { value: "Autos nuevos", label: "Autos nuevos" },
  { value: "Autos usados", label: "Autos usados" },
  { value: "Planes de financiamiento", label: "Planes de financiamiento" },
  { value: "Servicio", label: "Servicio" },
  { value: "Otros", label: "Otros" },
];

const FormularioWrapper = () => {
  const location = useLocation();
  useGoogleTagManager(process.env.REACT_APP_ICDC_GTM_ID);

  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_GA4 === "true") {
      ReactGA.initialize(process.env.REACT_APP_AUDI_NUEVO_GA_ID);

      if (localStorage.getItem('consentModeSettings') === null || localStorage.getItem('consentModeSettings') === undefined) {
        ReactGA.gtag('consent', 'default', {
          'ad_user_data': 'granted',
          'ad_personalization': 'granted',
          'ad_storage': 'granted',
          'analytics_storage': 'granted'
        });
      } else {
        ReactGA.gtag('consent', 'default', JSON.parse(localStorage.getItem('consentModeSettings')));
      }
    }
  }, []);

  const validateTypeForm = () => {
    const pathname = location.pathname;

    if (pathname.includes('/lealtad')) {
      return FORM_TYPES.PREVENTA.LEALTAD;
    } else if (pathname.includes('/conquista')) {
      return FORM_TYPES.PREVENTA.CONQUISTA;
    }

    return FORM_TYPES.NUEVO;
  };

  const formType = validateTypeForm();
  const utms = useUtmParams();

  return <FormAudiNuevo formType={formType} utms={utms} />;
};

export default FormularioWrapper;

const FormAudiNuevo = ({ formType, utms }) => {
  const dispatch = useDispatch();
  const objSubmit = useSelector((state) => state.audiNuevo);
  const [codigoPostal, setCodigoPostal] = useState("");

  const { modelPathName } = useParams();
  let navigate = useNavigate();

  const setTratamiento = (inNombre) => {
    dispatch(setTratamientoAction(inNombre));
  };
  const setNombre = (inNombre) => {
    dispatch(setNombreAction(inNombre));
  };
  const setApellidoPaterno = (inApellidoPaterno) => {
    dispatch(setApellidoPaternoAction(inApellidoPaterno));
  };
  // const setTelefono = (inTelefono) => {
  //     dispatch(setTelefonoAction(isOnlyNumbers(inTelefono)));
  // };
  const setMovil = (inMovil) => {
    dispatch(setMovilAction(isOnlyNumbers(inMovil)));
  };
  const setCorreo = (inCorreo) => {
    dispatch(setCorreoAction(inCorreo));
  };
  const setEstado = (inEstado) => {
    dispatch(setEstadoAction(inEstado));
  };
  const setCiudad = (inCiudad) => {
    dispatch(setCiudadAction(inCiudad));
  };
  const setIdConcesionario = (inIdConcesionario) => {
    dispatch(setIdConcesionarioAction(inIdConcesionario));
  };
  const setConcesionario = (inConcesionario) => {
    dispatch(setConcesionarioAction(inConcesionario));
  };
  const setVehiculo = (inVehiculo) => {
    dispatch(setVehiculoAction(inVehiculo));
  };
  const setComentarios = (inComentarios) => {
    dispatch(setComentariosAction(inComentarios));
  };
  const setAvisosDePrivacidad = (inAvisosDePrivacidad) => {
    dispatch(setAvisosDePrivacidadAction(inAvisosDePrivacidad));
  };
  const setTerminosCondiciones = (inTerminosCondiciones) => {
    dispatch(setTerminosCondicionesAction(inTerminosCondiciones));
  };
  const setTransferenciaDeDatos = (inAvisosDePrivacidad) => {
    dispatch(setTransferenciaDeDatosAction(inAvisosDePrivacidad));
  };
  const setContactoMarketing = (inTerminosCondiciones) => {
    dispatch(setContactoMarketingAction(inTerminosCondiciones));
  };

  const [infoNameForm, setInfoNameForm] = useState("Quiero un Audi nuevo");
  const [titleSeo, setTitleSeo] = useState('');
  const [infoKeySalesforce, setInfoKeySalesforce] = useState("");
  const [infoPathName, setInfoPathName] = useState("");
  const [infoImage, setInfoImage] = useState("forms_audi_banner-quiero-un-audi-nuevo_home.jpg");
  const [tipoServicio, setTipoServicio] = useState("Autos nuevos");

  const [estados, setEstados] = useState([]);
  const [ciudades, setCiudades] = useState([]);
  const [concesionarios, setConcesionarios] = useState([]);
  const [modelos, setModelos] = useState(dataModelos);
  const [tradeInData, setTradeInData] = useState(null);

  const [showErrorEstado, setErrorEstado] = useState(false);
  const [showErrorCiudad, setErrorCiudad] = useState(false);
  const [showErrorConcesionario, setErrorConcesionario] = useState(false);
  const [showErrorVehiculo, setErrorVehiculo] = useState(false);
  const [showErrorServicio, setErrorServicio] = useState(false);
  const [showErrorDeclaraciones, setErrorDeclaraciones] = useState(false);
  const [showErrorCodigoPostal, setErrorCodigoPostal] = useState(false);

  const [loadingSubmit, setLoadingSubmit] = useState(false);
  const [showErrorSubmit, setShowErrorSubmit] = useState(false);

  const filterCiudades = useMemo(() => {
    if (estados.length > 0 && ciudades.length > 0) {
      const estadoSelected = estados.find(
        (edo) => edo.nombreedo === objSubmit.provincia
      );

      if (estadoSelected === undefined) return [];

      return ciudades.filter(
        (cd) => cd.idestado.idestado === estadoSelected.idestado
      );
    }
    return [];
  }, [objSubmit.provincia, estados, ciudades]);

  const filterConcesionarios = useMemo(() => {
    if (concesionarios.length > 0 && estados.length > 0) {
      const estadoSelected = estados.find(
        (edo) => edo.nombreedo === objSubmit.provincia
      );

      if (estadoSelected === undefined) return [];

      return concesionarios.filter(
        (concesionario) => concesionario.stateName === estadoSelected.nombreedo
      );
    }
    return [];
  }, [objSubmit.provincia, estados, concesionarios]);

  useEffect(() => {
    const funGetEstado = async () => {
      getEstados().then((responseEstados) => {
        setEstados(responseEstados.data);
      });
    };
    const funGetCiudades = async () => {
      getCiudades().then((responseCiudades) => {
        setCiudades(responseCiudades.data);
      });
    };

    const funGetConcesionarios = async () => {
      getConcesionarios().then((responseConcesionarios) => {
        const filterConcesionarios = getOnlyAudiCenters(responseConcesionarios.data.data);
        setConcesionarios(filterConcesionarios);
      });
    };

    const filterModelos = dataModelos.filter(model => model.active === true);

    funGetEstado();
    funGetCiudades();
    funGetConcesionarios();
    setModelos(filterModelos);
  }, []);

  useEffect(() => {
    if (modelPathName === undefined) {
      if (formType === FORM_TYPES.PREVENTA.LEALTAD || formType === FORM_TYPES.PREVENTA.CONQUISTA) {
        navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND);
      }

      setTitleSeo("Quiero un Audi nuevo - General");
    } else {
      const infoActualModel = dataModelos.find(model => model.active === true && model.pathName === modelPathName);
      if (infoActualModel) {
        if (formType === FORM_TYPES.PREVENTA.LEALTAD || formType === FORM_TYPES.PREVENTA.CONQUISTA) {
          if (infoActualModel.preventa === undefined || infoActualModel.preventa === false) {
            navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND);
            return;
          }
          if (!TITLE[modelPathName] || !LEGALS[modelPathName]) {
            navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND);
            return;
          }
        } else {
          if (infoActualModel.preventa === true) {
            navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND);
            return;
          }
        }

        setInfoNameForm(infoActualModel.name);
        setInfoKeySalesforce(infoActualModel.keySalesforce);
        setInfoPathName(infoActualModel.pathName);
        setInfoImage(infoActualModel.image);

        setTitleSeo("Quiero un Audi nuevo - " + infoActualModel.name);
      } else {
        navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOFORMNOTFOUND);
      }
    }
  }, [modelPathName, formType, navigate]);

  const onSubmit = (e) => {
    e.preventDefault();

    const dataIsvalid = validateForm();

    if (dataIsvalid) {
      setLoadingSubmit(true);
      setShowErrorSubmit(false);
      const lead = { ...objSubmit }

      lead.numeroConcesionaria = objSubmit.numeroConcesionaria < 1000
        ? "0" + objSubmit.numeroConcesionaria
        : "" + objSubmit.numeroConcesionaria

      lead.llaveOrigen = "AUSW" + new Date().getTime()


      delete lead.avisoPrivacidad
      delete lead.terminosCondiciones
      delete lead.nombreDelVehiculo

      lead.descripcion = tipoServicio + " - " + (lead.descripcion.trim() === "" ? "Sin comentarios" : lead.descripcion.trim());

      if (modelPathName === undefined) {
        lead.tercerNivel = "Sitio Web Audi - seccion ayuda";
      } else {
        lead.vehiculoInteres = infoKeySalesforce
        lead.tercerNivel = "Sitio Web Audi - home modelos";
      }

      if (formType === FORM_TYPES.PREVENTA.LEALTAD || formType === FORM_TYPES.PREVENTA.CONQUISTA) {
        const campaignConfig = resolvePreventaQ3Config(formType, utms);


        if (campaignConfig.fuenteSitioWeb) lead.fuenteSitioWeb = campaignConfig.fuenteSitioWeb;
        if (campaignConfig.tipoRegistro) lead.tipoRegistro = campaignConfig.tipoRegistro;
        if (campaignConfig.marca) lead.marca = campaignConfig.marca;
        if (campaignConfig.fuenteSecundaria) lead.fuenteSecundaria = campaignConfig.fuenteSecundaria;
        if (campaignConfig.tercerNivel) lead.tercerNivel = campaignConfig.tercerNivel;
        if (campaignConfig.tipoCita) lead.tipoCita = campaignConfig.tipoCita;

      }

      sendLead(lead)
        .then((response) => {
          const idTransaccion = response?.data?.idTransaccion || null;
          const leadWithUtms = addUtmsToLead(lead, utms);

          window.dataLayer = window.dataLayer || [];
          window.dataLayer.push({
            event: 'lead_enviado',
            idTransaccion: idTransaccion
          });

          sendMailAudiNuevoCliente(lead)
          sendMailAudiNuevoConcesionaria(lead)
          setLoadingSubmit(false);
          dispatch(reiniciarStateAction());
          handleSendLeadToSaas(leadWithUtms, response?.data?.idTransaccion, true, modelPathName === undefined ? "Formulario General" : lead.vehiculoInteres, response?.data?.message);

          if (ReactGA.isInitialized) {
            ReactGA.event(`lead_enviado_${modelPathName ? modelPathName : "general"}_${response?.data?.idTransaccion}`, {
              category: 'Audi Nuevo',
              action: 'Lead enviado exitosamente',
              label: 'Nuevo Lead Audi Nuevo',
              once: true,
              value: 1,
            });
          }

          if (tradeInData) {
            const tradeInPayload = buildTradeInPayload(lead, tradeInData, codigoPostal);
            sendTradeIn(tradeInPayload)
              .then((res) => console.log("Trade-in enviado:", res))
              .catch((err) => console.error("Error trade-in:", err));
          }

          if (formType === FORM_TYPES.PREVENTA.LEALTAD) {
            navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOTHANKYOUEMPTY + "/lealtad/" + modelPathName)
          }
          else if (formType === FORM_TYPES.PREVENTA.CONQUISTA) {
            navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOTHANKYOUEMPTY + "/conquista/" + modelPathName)
          }
          else {
            modelPathName === undefined
              ? navigate(ROUTES.AUDINUEVOTHANKYOUEMPTY)
              : navigate(ROUTES.AUDINUEVOGENERAL + ROUTES.AUDINUEVOTHANKYOUEMPTY + "/" + modelPathName, { state: { salesforceId: response?.data?.idTransaccion } })
          }

        })
        .catch((error) => {
          const leadWithUtms = addUtmsToLead(lead, utms);
          handleSendLeadToSaas(leadWithUtms, error?.response?.data?.idTransaccion || null, false, modelPathName === undefined ? "Formulario General" : lead.vehiculoInteres, error?.response?.data?.message || error?.message || "Error en envío de lead");
          setLoadingSubmit(false);
          setShowErrorSubmit(true);
          console.log("ERROR: ", error);
        });
    }

  }

  const handleSendLeadToSaas = (lead, idTransaccion, status, model, message) => {
    sendLeadToSaas(lead, process.env.REACT_APP_FORM_ID_AUDI_NUEVO, idTransaccion, status, model, message)
      .then(respuesta => {
        // manejar respuesta
      })
      .catch(error => {
        // manejar error
        console.error("Error en log: " + error)
      });
  }

  const validateForm = () => {
    if (validarNombre(objSubmit.nombre) === false) {
      scrollToInput("nombre", "Por favor ingresa un nombre válido");
      return false
    }
    if (validarApellidoPaterno(objSubmit.apellidoPaterno) === false) {
      scrollToInput("apellidoPaterno", "Por favor ingresa un valor válido");
      return false;
    }
    // if (validarTelefono(objSubmit.telefono) === false) {
    //     scrollToInput("telefono", "Por favor ingresa un valor válido");
    //     return false;
    // }
    if (validarCelular(objSubmit.celular) === false) {
      scrollToInput("movil", "Por favor ingresa un valor válido");
      return false;
    }
    if (validarCorreo(objSubmit.email) === false) {
      scrollToInput("correo", "Por favor ingresa un valor válido");
      return false;
    }

    if (validarCodigoPostal(codigoPostal) === false) {
      scrollToInput("codigoPostal", "Por favor ingresa un valor válido");
      return false;
    }

    if (objSubmit.provincia === "") {
      scrollToInput("estado");
      setErrorEstado(true);
      return false;
    } else {
      setErrorEstado(false);
    }
    if (objSubmit.ciudad === "") {
      scrollToInput("ciudad");
      setErrorCiudad(true);
      return false;
    } else {
      setErrorCiudad(false);
    }
    if (objSubmit.numeroConcesionaria === "" || objSubmit.concesionariaPreferida === "") {
      scrollToInput("concesionario");
      setErrorConcesionario(true);
      return false;
    } else {
      setErrorConcesionario(false);
    }
    if (objSubmit.vehiculoInteres === "" && infoPathName === "") {
      scrollToInput("vehiculo");
      setErrorVehiculo(true);
      return false;
    } else {
      setErrorVehiculo(false);
    }
    if (objSubmit.tipoCita === "") {
      scrollToInput("servicio");
      setErrorServicio(true);
      return false;
    } else {
      setErrorServicio(false);
    }
    if (objSubmit.descripcion.length > 1000) {
      scrollToInput("comentarios");
      return false;
    } else {
      setErrorServicio(false);
    }

    if (
      objSubmit.avisoPrivacidad === false ||
      objSubmit.terminosCondiciones === false ||
      objSubmit.permisoTransferenciaDatos === false ||
      objSubmit.permisoContactoMarketing === false
    ) {
      setErrorDeclaraciones(true);
      return false;
    } else {
      setErrorDeclaraciones(false);
    }

    return true
  }

  return (
    <>
      <SeoPixel
        title_form={titleSeo}
        description="El mejor asesoramiento posible."
        keywords={"audi,nuevo,contacto,formulario," + infoNameForm}
        image={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage}
        url={process.env.REACT_APP_DOMAIN + (modelPathName === undefined
          ? ROUTES.AUDINUEVOGENERAL.substring(0, ROUTES.AUDINUEVOGENERAL.length - 1)
          : ROUTES.AUDINUEVOGENERAL + modelPathName)}
      />
      {
        process.env.REACT_APP_ENABLE_GA4 === "true" && <ConsentMode />
      }
      {
        process.env.REACT_APP_ENABLE_META_PIXEL === "true" && <MetaPixel />
      }
      {
        process.env.REACT_APP_ENABLE_TWITTER_PIXEL === "true" && <TwitterPixel />
      }
      {
        process.env.REACT_APP_ENABLE_FLOODLIGHT === "true" && <FloodlightPixel />
      }

      <main className="audi-nuevo">
        <Stage title={formType === FORM_TYPES.PREVENTA.LEALTAD || formType === FORM_TYPES.PREVENTA.CONQUISTA ? `Preventa ${infoNameForm}` : infoNameForm}
          img={process.env.REACT_APP_RESOURCES_IMAGES_PATH + "formsSalesforce/" + infoImage}
        />
        <div className="container button-back-container">
          <ButtonBack />
        </div>
        <section className="container w-100 pt-3">
          <TitleComponent formType={formType} modelPathName={modelPathName} utms={utms} infoNameForm={infoNameForm} />

          <form className="w-100 pt-5" onSubmit={onSubmit}>
            <TratoComponent value={objSubmit.tratamiento} onChange={(e) => { setTratamiento(e.target.value) }} />

            <h3>Datos de contacto</h3>
            <div className="fields-grid mt-4 mb-5">
              <div className="order-1">
                <InputText
                  label="¿Cuál es tu nombre?"
                  name="nombre"
                  secondaryLabel="Nombre"
                  maxLength={40}
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    setNombre(value);
                  }}
                  validator={validarNombre}
                  errorMessage={objSubmit.nombre.length > 40 ? "Máx. 40 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                />
              </div>
              <div className="order-2">
                <InputText
                  label="¿Cuál es tu apellido?"
                  name="apellidoPaterno"
                  secondaryLabel="Apellido"
                  maxLength={80}
                  onBlur={(e) => {
                    const value = e.target.value.trim();
                    setApellidoPaterno(value);
                  }}
                  errorMessage={objSubmit.apellidoPaterno.length > 80 ? "Máx. 80 cáracteres" : "Carácter no válido, por favor usa solo letras."}
                  validator={validarApellidoPaterno}
                />
              </div>
              {/* <div className="order-3">
                                <InputText
                                    label="¿Cuál es tu número de teléfono?"
                                    name="telefono"
                                    secondaryLabel="Teléfono"
                                    value={objSubmit.telefono}
                                    maxLength={10}
                                    onChange={(e) => {
                                        if (e.target.value.length <= 10) {
                                            setTelefono(e.target.value);
                                        }
                                    }}
                                    errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                                    validator={validarTelefono}
                                />
                            </div> */}
              <div className="order-3">
                <InputText
                  label="¿Cuál es tu número móvil?"
                  name="movil"
                  secondaryLabel="Móvil"
                  value={objSubmit.celular}
                  maxLength={10}
                  onChange={(e) => {
                    if (e.target.value.length <= 10) {
                      setMovil(e.target.value);
                    }
                  }}
                  errorMessage="Introduzca un número de teléfono válido a 10 dígitos."
                  validator={validarCelular}
                />
              </div>
              <div className="order-4 order-lg-6">
                <InputText
                  label="¿Cuál es tu e-mail?"
                  name="correo"
                  secondaryLabel="E-mail"
                  maxLength={80}
                  value={objSubmit.email}
                  onChange={(e) => {
                    if (e.target.value.length <= 80)
                      setCorreo(e.target.value);
                  }}
                  errorMessage="Por favor usa un e-mail válido con formato: nombre@dominio.com"
                  validator={validarCorreo}
                />
              </div>
              <div className="order-5 order-lg-4">
                <InputSelect
                  label="¿Cuál es tu estado?"
                  name="estado"
                  options={estados.map((item, i) => ({
                    value: item.nombreedo,
                    label: item.nombreedo,
                  }))}
                  onChange={(e) => {
                    setEstado(e.target.value);
                    setIdConcesionario("");
                    setConcesionario("");
                  }}
                  errorMessage="Selecciona una opción"
                  showError={showErrorEstado}
                  defaultValue={objSubmit.provincia}
                />
              </div>
              <div className="order-6">
                <InputSelect
                  label="¿Cuál es tu ciudad?"
                  name="ciudad"
                  options={filterCiudades.map((item, i) => ({
                    value: item.nombrecd,
                    label: item.nombrecd,
                  }))}
                  onChange={(e) => {
                    setCiudad(e.target.value);
                  }}
                  disabled={objSubmit.provincia === ""}
                  showError={showErrorCiudad}
                  errorMessage="Selecciona una opción"
                  defaultValue={objSubmit.ciudad}
                />
              </div>
              <div className="order-7">
                <InputText
                  label="¿Cuál es tu código postal?"
                  name="codigoPostal"
                  value={codigoPostal}
                  maxLength={5}
                  onChange={(e) => {
                    if (e.target.value.length <= 5) {
                      setCodigoPostal(e.target.value);
                    }
                  }}
                  showError={showErrorCodigoPostal}
                  errorMessage="Ingresa un código postal válido"
                  defaultValue={codigoPostal}
                  validator={validarCodigoPostal}
                />
              </div>
            </div>
            <h3 className="pt-5">Información de interés</h3>
            <div className="w-100 d-flex flex-column flex-md-row gap-5 mt-4 mb-5">
              <div className="fields-grid">
                <InputSelect
                  label="¿Cuál es tu concesionario de preferencia?"
                  name="concesionario"
                  options={filterConcesionarios.map((item, i) => ({
                    value: item.dealerNumber,
                    label: item.name,
                  }))}
                  onChange={(e) => {
                    const concesionario = concesionarios.find(
                      (con) => con.dealerNumber === parseInt(e.target.value)
                    );

                    setIdConcesionario(concesionario.dealerNumber);
                    setConcesionario(concesionario.name);
                  }}
                  showError={showErrorConcesionario}
                  noDataMessage={objSubmit.provincia === "" ? "Para seleccionar el concesionario, por favor, primero selecciona tu estado" : "No hay concesionarios, por favor, selecciona otro estado."}
                  showNoDataMessage={objSubmit.provincia !== ""}
                  errorMessage="Selecciona una opción"
                  defaultValue={objSubmit.numeroConcesionaria}
                />
                <InputSelect
                  label="¿En qué podemos apoyarte?"
                  name="servicio"
                  options={tiposDeServicio.map((item, i) => ({
                    value: item.value,
                    label: item.label,
                  }))}
                  onChange={(e) => {
                    setTipoServicio(e.target.value);
                  }}
                  showError={showErrorServicio}
                  errorMessage="Selecciona una opción"
                  defaultValue={tipoServicio}
                />
              </div>

              {
                modelPathName === undefined && <div className="d-flex flex-column gap-5">
                  <InputSelect
                    label="¿Cuál es tu vehículo de interés?"
                    name="vehiculo"
                    options={modelos.map((item, i) => ({
                      label: item.name,
                      value: item.keySalesforce,
                    }))}
                    onChange={(e) => {
                      setVehiculo(e.target.value);
                    }}
                    showError={showErrorVehiculo}
                    defaultValue={objSubmit.vehiculoInteres}
                    errorMessage="Selecciona una opción"
                  />
                </div>
              }

            </div>
            <div>
              <InputTextArea
                name="comentarios"
                placeholder="Escribe aquí las dudas o información que te gustaría conocer."
                errorMessage="Tu comentario excede los 1,000 caracteres"
                maxLength={1000}
                onChange={(e) => {
                  setComentarios(e.target.value);
                }}
                isValid={true}
              />
            </div>

            <TradeInSection onTradeInChange={setTradeInData} />

            <div className="mt-5 pt-5">
              <h3 >Estamos comprometidos con tu privacidad</h3>
              <p className="mt-4 pb-5" style={{ textAlign: 'justify' }}>
                En Audi usamos la información que nos proporcionas para ofrecerte contenido de valor sobre los productos y servicios con los que contamos. Permítenos brindarte una mejor experiencia, a través de un contacto personalizado al aceptar los siguientes avisos:
              </p>

              <div className="d-flex flex-column gap-3">
                <InputCheckBox
                  rounded
                  label="Aceptar todo"
                  onChange={(e) => {
                    setAvisosDePrivacidad(e.target.checked);
                    setTerminosCondiciones(e.target.checked);
                    setTransferenciaDeDatos(e.target.checked);
                    setContactoMarketing(e.target.checked);
                  }}
                />

                <InputCheckBox
                  name="checkboxgroup"
                  checked={objSubmit.avisoPrivacidad}
                  onChange={(e) => {
                    setAvisosDePrivacidad(e.target.checked);
                  }}
                >
                  <span>
                    He leído y acepto el{" "}
                    <a
                      href="https://www.audi.com.mx/es/tools/navigation/layer/legal/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Aviso de Privacidad.
                    </a>
                  </span>
                </InputCheckBox>
                <InputCheckBox
                  name="checkboxgroup"
                  checked={objSubmit.terminosCondiciones}
                  onChange={(e) => {
                    setTerminosCondiciones(e.target.checked);
                  }}
                >
                  <span>
                    He leído y acepto el{" "}
                    <a
                      href="https://www.audi.com.mx/es/tools/navigation/layer/terminos_y_condiciones/"
                      target="_blank"
                      rel="noreferrer"
                    >
                      Términos y Condiciones.
                    </a>
                  </span>
                </InputCheckBox>
                <InputCheckBox
                  label="Acepto que los datos aquí proporcionados sean transferidos al Concesionario marca Audi que he elegido, para dar seguimiento a mi solicitud."
                  name="checkboxgroup"
                  checked={objSubmit.permisoTransferenciaDatos}
                  onChange={(e) => {
                    setTransferenciaDeDatos(e.target.checked);
                  }}
                />
                <InputCheckBox
                  label="Acepto que los datos aquí proporcionados sean transferidos a Facebook Mexico S. de R.L. de C.V., Twitter, Inc. y Google Operaciones de México, S. de R.L. de C.V., para efectos de marketing."
                  name="checkboxgroup"
                  checked={objSubmit.permisoContactoMarketing}
                  onChange={(e) => {
                    setContactoMarketing(e.target.checked);
                  }}
                />

                <span
                  className={`inValid-input ${showErrorDeclaraciones ? "" : "d-none"
                    }`}
                >
                  Para continuar, acepta nuestras declaraciones de conformidad.
                </span>

              </div>

            </div>

            <LegalesComponent formType={formType} modelPathName={modelPathName} utms={utms} />
            <div>
              {!loadingSubmit ? (
                <button className={`button-enviar`} type="submit">
                  Enviar
                </button>
              ) : (
                <button
                  className="button-enviar disabled"
                  type="button"
                  disabled={true}
                >
                  <div className="loading-g loading-send loading-btn">
                    <div>
                      <ReactLoading
                        type="cylon"
                        color="#fff"
                        width={"100%"}
                        height={"58px"}
                      />
                    </div>
                  </div>
                </button>
              )}
            </div>
            <span
              className={`mb-5 inValid-input d-block ${!showErrorSubmit ? "d-none" : ""
                }`}
            >
              Hubo un error. Por favor, Intentelo más tarde.
            </span>
          </form>
        </section>
      </main>
    </>
  );
};